import { post, get, put } from "./methods";

export const getCaseList = () => post("/api/mr/depart-manage/list");
export const getCaseDetail = (id: string) => get("/api/mr/depart-manage/" + id);
export const getCaseDetailMobile = (id: string) => get("/api/mr/depart-manage/mobile/" + id);
export const thumbsUp = (id: string) => get("/api/mr/thumbs-up/" + id);
export const sendSms = (mobile: string) => post("/api/mr/user/sendSms/" + mobile);
export const mobileLogin = (params: any) => post("/api/mr/user/mobile/login", params);
export const thumbsUpNum = () => get("/api/mr/thumbs-up/thumbs-up-num/");
